/*
Lalitha 12/28/2022 3075154998 Add new Component SelectField Table
Dilip 01/12/2023 3075154998 changed delete pop up message
Dilip 01/12/2023 3075154998 added delete disable condition
Ashraf 01/31/2023 3075154998 Added Sort fields
 Ravi 01/31/2023 3075154998 fixed unsaved popup issue
 Sohel 02/07/2023 2698959212 fixed fieldType populate issue
 Prakash 20/04/2023 2698959212 fixed font issue in table
Ravi 05/31/2023 2698959212  changed delete popup message
Ravi 05/31/2023 2698959212  changed delete popup message
Akhila 06/12/2023 2698959212 added role access
 */

import React, {useState} from 'react';
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';

export default function DMSelectFieldsTable({
  selectedRows,
  deletedSelectedFields,
  setSelectedRows,
  exportManager,
  handleDirty,
  editExisting,
  DataManagerAccess,
}) {
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const arr = [...selectedRows];
        const newData = arr.filter(
          (row) =>
            row.fieldName.concat(row.repositoryName) !==
            deleteData?.fieldName.concat(deleteData?.repositoryName),
        );
        const newDeletedIds = [...deletedSelectedFields.current];
        if (deleteData?.dataManagerRecordId) {
          newDeletedIds.push(deleteData?.dataManagerRecordId);
        }
        deletedSelectedFields.current = [...deletedSelectedFields.current, ...newDeletedIds];
        setSelectedRows(newData);
        handleDeleteClose();
        resolve();
      }, 1000);
      handleDirty(true);
    });
  };
  const columns = [
    // {
    //   title: "Category",
    //   width: "1%",
    //   hidden: exportManager,
    //   render: (rowData) => {
    //     return rowData?.category === "C"
    //       ? "C - Client"
    //       : rowData?.category === "D"
    //         ? "D - Debtor"
    //         : rowData?.category === "P"
    //           ? "P - Payment"
    //           : "";
    //   },
    // },
    {
      title: 'Repository Name',
      field: 'repositoryName',
    },
    {
      title: 'Field Name',
      field: 'fieldName',
    },
    {
      title: 'Field Type',
      field: 'processorFieldType',
    },
    {
      title: 'Data Type',
      field: 'dataType',
    },
  ];

  const [rows, setRows] = useState(defaultRows);
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Field"
        value={`Are you sure you want to delete the ${deleteData?.fieldName} Field?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={selectedRows}
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              (rowData) => {
                return {
                  icon: () => <DeleteOutlineOutlinedIcon />,
                  tooltip: 'Delete',
                  disabled:
                    selectedRows?.length === 1 ||
                    ((rowData?.type === 'Record' || rowData?.type === 'Record Group') &&
                      exportManager) ||
                    (editExisting && !DataManagerAccess?.edit),
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
